import { Link, useLocation } from "react-router-dom";
import { useI18n } from "../../i18n/I18nProvider";

const TABS = [
  { to: "/vehicles", key: "veh.tab.overview" },
  { to: "/vehicles/list", key: "veh.tab.all" },
  { to: "/vehicles/trailers", key: "trl.title" },
  { to: "/vehicles/inspections", key: "veh.tab.inspections" },
  { to: "/vehicles/services", key: "veh.tab.services" },
  { to: "/vehicles/co2", key: "veh.tab.co2" },
  { to: "/vehicles/rental-reports", key: "rrep.title" },
  { to: "/vehicles/documents", key: "veh.tab.documents" },
];

export default function VehiclesSubNav() {
  const { pathname } = useLocation();
  const { t } = useI18n();
  return (
    <div className="border-b border-[var(--ink-200)] mb-8" data-testid="vehicles-subnav">
      <div className="flex flex-wrap gap-1">
        {TABS.map((tab) => {
          const active = tab.to === "/vehicles"
            ? pathname === "/vehicles"
            : pathname === tab.to || pathname.startsWith(tab.to + "/");
          return (
            <Link
              key={tab.to}
              to={tab.to}
              data-testid={`vehicles-tab-${tab.to.split("/").pop() || "overview"}`}
              className={`px-4 py-2 text-xs font-mono-tech uppercase tracking-[0.1em] border-b-2 -mb-px transition-colors ${
                active
                  ? "border-[var(--ink)] text-[var(--ink)] bg-[var(--surface-alt)]"
                  : "border-transparent text-[var(--ink-500)] hover:text-[var(--ink)] hover:bg-[var(--surface-alt)]"
              }`}
            >
              {t(tab.key)}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
